import React, { useEffect, useState } from "react";
import { IoPersonSharp } from "react-icons/io5";
import Edit from "../../../Assets/Icons/edit1.svg";
import View from "../../../Assets/Icons/visibility.svg";
import Share from "../../../Assets/Icons/share1.svg";
import EditWhite from "../../../Assets/Images/Svg/EditWhite.svg";
import ViewWhite from "../../../Assets/Images/Svg/ViewWhite.svg";
import ShareWhite from "../../../Assets/Images/Svg/ShareWhite.svg";
import MedWhite from "../../../Assets/Images/Svg/MedWhite.svg";
import LabWhite from "../../../Assets/Images/Svg/LabWhite.svg";
import close from "../../../Assets/Icons/close1.svg";
import Lab from "../../../Assets/Icons/lab1.svg";
import Med from "../../../Assets/Icons/tablt.svg";
import { BiVideoPlus } from "react-icons/bi";
import { useHistory } from "react-router-dom";
import { useForm } from "antd/es/form/Form";
import AppointmentService from "../../../Services/AppointmentService";
import { Button, Checkbox, message, Modal, Tooltip } from "antd";
import enrollmentServices from "../../../Services/enrollmentServices";
import ConsultationService from "../../../Services/ConsultationService";
import PatientService from "../../../Services/PatientService";
import { RWebShare } from "react-web-share";
import CommonFunctions from "../../Shared/CommonFunctions";
import { APP_ROUTES } from "../../../PageRouting/approutes";
import ShareOrders from "./ShareOrders";
import moment from "moment";
import SharePrescription from "./SharePrescription";
import PrescriptionDetails from "../ConsultationNotes/VitalTabs/ViewPrescription/PrescriptionDetails";
import NoAppointmentsCard from "../Appointments/NoAppointmentsCard";
import { IoMdClose } from "react-icons/io";
import RescheduleAppt from "./RescheduleAppt";
import { FaCalendarAlt } from "react-icons/fa";
import { getLoaderState } from "../../../Redux/actions/CommonActions";
import { useDispatch } from "react-redux";
import ViewLabReports from "../Appointments/ViewLabReports";
import MedOrderPreview from "../Appointments/MedOrderPreview";
import LabOrderPreview from "../Appointments/LabOrderPreview";
import Preview from "../../../Assets/Images/Svg/PreviewIcon.svg";
import Summary from "../VideoConsultation/Summary";

function Appointments({
  appointmentsList,
  patientsInviteList,
  setPatientsInviteList,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cancelAppointmentID, setCancelAppointmentID] = useState({});
  const [preview, setPreview] = useState(false);
  const [selectedPrescription, setSelectedPrescription] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [form, setForm] = useForm();
  const [cancelReason, setCancelReason] = useState("");
  const [refundable, setRefundable] = useState(false);
  const history = useHistory();

  const [previewType, setPreviewType] = useState("M");
  const [showLabReport, setShowLabReport] = useState(false);
  const [labReportData, setLabReportData] = useState({});
  const [pharmaMed, setPharmaMed] = useState(false);
  const [pharmaLab, setPharmaLab] = useState(false);
  const [medRecord, setMedRecord] = useState({});
  const [loading, setLoading] = useState(false);

  const handlePharmaMedOpen = (record, type) => {
    setPreviewType(type);
    setMedRecord(record);
    setPharmaMed(true);
  };

  const handlePharmaMedClose = () => {
    setPharmaMed(false);
  };

  const handlePreviewOk = () => {
    setPreview(false);
  };
  const handlePreviewCancel = () => {
    setPreview(false);
  };

  useEffect(() => {
    if (
      cancelAppointmentID &&
      cancelAppointmentID.status === 1
      // &&
      // cancelAppointmentID.paymentType === "Digital"
    ) {
      setRefundable(true);
    }
  }, [cancelAppointmentID]);

  const showModal = (record) => {
    setIsModalOpen(true);
    setCancelAppointmentID(record);
  };

  const handleOk = () => {
    if (cancelReason === "") {
      message.error("Enter reason");
      return;
    }
    let payload = {
      appointmentId: cancelAppointmentID.appointmentId,
      cancelReason: cancelReason,
      cancelledById: cancelAppointmentID.userId,
      cancelledByType: "USER",
      refundYN: refundable ? "Y" : "N",
      paymentType: cancelAppointmentID.paymentType,
    };
    AppointmentService.AppointmentCancelNew(payload)
      .then((res) => {
        setIsModalOpen(false);
        appointmentsList();
        message.success("Appointment Cancelled");
        setCancelReason("");
        setRefundable(false);
        setCancelAppointmentID({});
      })
      .catch((error) => {
        message.error("Please try again");
      });
  };

  const cancelAppointment = () => {
    setIsModalOpen(false);
    setRefundable(false);
  };

  const handleClick = async (record, tab) => {
    dispatch(getLoaderState(true));

    if (tab === "1") {
      let payload = {
        appointmentId: record.appointmentId,
        modifiedBy: record.userId,
        modifiedDate: CommonFunctions.convertUTCDate(
          new Date(),
          "YYYY-MM-DD HH:mm:ss"
        ),
        patientId: record.patientId,
        startDateTime: CommonFunctions.convertUTCDate(
          new Date(),
          "YYYY-MM-DD HH:mm:ss"
        ),
        userId: record.userId,
      };

      ConsultationService.updateStartTime(payload).then((res) => {});
    }
    try {
      let payload = {
        patientId: record.patientId,
      };

      PatientService.PatientListFilter(payload).then((res) => {
        localStorage.setItem("patient", JSON.stringify(res.data[0]));
      });

      let apptPayload = {
        appointmentId: record.appointmentId,
      };

      let result = await AppointmentService.AppointmentFilter(apptPayload);
      history.push(APP_ROUTES.VIDEOCALL, { selectedPatient: result?.data[0] });
      window.scrollTo(0, 0);
    } catch (error) {
      message.error("An error occured try again");
    } finally {
      dispatch(getLoaderState(false));
    }
  };

  const dispatch = useDispatch();

  const showPreview = async (record) => {
    dispatch(getLoaderState(true));
    let patientPayload = {
      patientId: record?.patientId,
    };
    let consultationPayload = {
      consultationId: record?.consultationId,
      detailsYN: "Y",
    };
    try {
      const patientResponse = await PatientService.PatientListFilter(
        patientPayload
      );
      if (patientResponse) {
        setSelectedPatient(patientResponse.data[0]);
      }
      const consultationResponse = await ConsultationService.getPrescriptions(
        consultationPayload
      );
      if (consultationResponse.data) {
        setSelectedPrescription(consultationResponse.data[0]);
        setPreview(true);
      }
      dispatch(getLoaderState(false));
    } catch (e) {
      console.error(e);
      dispatch(getLoaderState(false));
    }
  };

  const handleRefundable = () => {
    setRefundable(!refundable);
  };

  const statusColors = {
    Success: "bg-[#31E4A81A] text-green-600",
    Failed: "bg-[#FF60601A] text-red-600",
    Pending: "bg-[#EBA8171A] text-yellow-600",
    Completed: "bg-[#31E4A81A] text-green-600",
    Canceled: "bg-[#FF60601A] text-red-600",
  };

  const getInitials = (name) => {
    if (!name) return "";
    name = name.replace(/^Mr\.?\s*/, "").trim();
    const initials = name.slice(0, 1).toUpperCase();
    return initials;
  };

  return (
    <div className="overflow-x-auto mx-4 my-2">
      {patientsInviteList && patientsInviteList.length > 0 ? (
        <table className="min-w-full  border border-gray-200 shadow-md rounded-md customTable ">
          <thead className="bg-[#F5FEFA] text-[#333333] text-left text-sm font-sans font-medium">
            <tr>
              <th className="p-3 whitespace-nowrap text-[#F5FEFA]">Image</th>
              <th className="p-3 whitespace-nowrap">Patient</th>
              <th className="p-3 whitespace-nowrap">Appt. ID</th>
              <th className="p-3 whitespace-nowrap">Chief Complaints</th>
              <th className="p-3 whitespace-nowrap">Date & Time</th>
              <th className="p-3 whitespace-nowrap">Call Type</th>
              <th className="p-3 whitespace-nowrap">Rx</th>
              <th className="p-3 whitespace-nowrap">Refill Date</th>
              <th className="p-3 whitespace-nowrap">Payment Status</th>
              <th className="p-3 whitespace-nowrap">Orders</th>
              <th className="p-3 whitespace-nowrap">Med Order ID</th>
              <th className="p-3 whitespace-nowrap">Lab Order ID</th>
              <th className="p-3 whitespace-nowrap">Appointment Status</th>
              <th className="p-3 whitespace-nowrap">Action</th>
            </tr>
          </thead>
          <tbody className="text-sm ">
            {patientsInviteList.map((record, index) => (
              <tr
                key={index}
                className="border-t border-gray-200 hover:bg-gray-50 font-sans font-medium text-sm text-[#333333]"
              >
                <td className="p-3">
                  {record.photoName ? (
                    <img
                      src={process.env.REACT_APP_IMAGE_URL + record?.photoName}
                      alt={record.name}
                      className="w-10 h-10 rounded-full"
                    />
                  ) : (
                    <div className="h-10 w-10 rounded-full flex items-center justify-center text-white bg-brand-primaryColor">
                      <span>{getInitials(record.patientName)}</span>
                    </div>
                  )}
                </td>
                <td className="p-3 whitespace-nowrap flex flex-col">
                  <span>{record.patientName}</span>
                  <span className="text-brand-textDarkgray text-xs mb-0">
                    {record.patientId}
                  </span>
                </td>
                <td className="p-3 whitespace-nowrap align-top">
                  {record.appointmentId}
                </td>
                <td className="p-3 whitespace-nowrap align-top">
                  {record.appointmentReason}
                </td>
                <td className="p-3 whitespace-nowrap">
                  <span className="flex flex-col">
                    <span>
                      {moment
                        .utc(record.appointmentDate)
                        .local()
                        .format("DD/MM/YYYY")}
                    </span>
                    <span>{record.startTime}</span>
                  </span>
                </td>
                <td className="p-3">
                  {record.status === 2 || record.status === 9 ? (
                    <button
                      className="flex items-center justify-center w-28 gap-2 px-1 py-2  bg-gray-400 rounded  text-white cursor-not-allowed"
                      disabled
                    >
                      {record.serviceCode === "APPT_VIDEO" ? (
                        <>
                          <BiVideoPlus className="w-5 h-5" />
                          Join call
                        </>
                      ) : (
                        <>
                          <IoPersonSharp className="w-5 h-5" /> Consult
                        </>
                      )}
                    </button>
                  ) : !record.transactionId &&
                    record.paymentConsultation === "BC" ? (
                    <Tooltip placement="top" title={"payment is not completed"}>
                      <button
                        className="bg-gray-400 text-white px-3 py-2 rounded flex items-center w-28 gap-1"
                        disabled
                      >
                        {record.serviceCode === "APPT_VIDEO" ? (
                          <>
                            <BiVideoPlus className="w-5 h-5" />
                            Join call
                          </>
                        ) : (
                          <>
                            <IoPersonSharp className="w-5 h-5" /> Consult
                          </>
                        )}
                      </button>
                    </Tooltip>
                  ) : (
                    <button
                      onClick={() => handleClick(record, "1")}
                      className="bg-brand-primaryColor text-white w-28 px-3 py-2 rounded flex items-center gap-1"
                    >
                      {record.serviceCode === "APPT_VIDEO" ? (
                        <>
                          <BiVideoPlus className="w-5 h-5" />
                          Join call
                        </>
                      ) : (
                        <>
                          <IoPersonSharp className="w-5 h-5" /> Consult
                        </>
                      )}
                    </button>
                  )}
                </td>

                <td>
                  {record.status === 2 ? (
                    <div className="p-3 flex gap-2">
                      <div
                        onClick={() => handleClick(record, "2")}
                        className="w-8 h-8 rounded-full bg-[#DEF3F2] flex items-center justify-center cursor-pointer"
                      >
                        <img src={Edit} alt="" />
                      </div>
                      <Tooltip placement="top" title={"View Prescription"}>
                        <div className="w-8 h-8 rounded-full bg-[#DEF3F2] flex items-center justify-center cursor-pointer">
                          <img
                            src={View}
                            alt=""
                            onClick={() => showPreview(record)}
                          />
                        </div>
                      </Tooltip>
                      <SharePrescription record={record} />
                    </div>
                  ) : (
                    <div className="p-3 flex gap-2">
                      <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                        <img src={EditWhite} alt="" />
                      </div>
                      <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                        <img src={ViewWhite} alt="" />
                      </div>
                      <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                        <img src={ShareWhite} alt="" />
                      </div>
                    </div>
                  )}
                </td>

                <td className="p-3 whitespace-nowrap">
                  <span
                    className={`px-4 py-2 rounded-md text-sm w-[104px] h-[28px] `}
                  >
                    {record?.refillDate ? (
                      <span>{record?.refillDate}</span>
                    ) : (
                      <span>{"N/A"}</span>
                    )}
                  </span>
                </td>

                <td className="p-3 whitespace-nowrap">
                  <span
                    className={`px-4 py-2 rounded-md text-sm w-[104px] h-[28px] ${
                      record.transactionId
                        ? "bg-[#31E4A81A] text-green-600"
                        : "bg-[#FF60601A] text-red-600"
                    }`}
                  >
                    {record.transactionId ? (
                      <span className="">Completed</span>
                    ) : (
                      <span className="">Pending</span>
                    )}
                  </span>
                </td>

                <td className="">
                  {record.status === 2 ? (
                    <div className="p-3 flex gap-2">
                      <ShareOrders record={record} getList={appointmentsList} />
                    </div>
                  ) : (
                    <div className="p-3 flex gap-2">
                      <span className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                        <img src={MedWhite} alt="" />
                      </span>
                      <span className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                        <img src={LabWhite} alt="" />
                      </span>
                    </div>
                  )}
                </td>
                <td className="p-3 whitespace-nowrap">
                  {record.drugPrescriptionStatus === "Dispensed" ? (
                    <div className="flex justify-center items-center">
                      <span
                        className=" border p-1 rounded-md border-brand-primaryColor cursor-pointer"
                        onClick={() => handlePharmaMedOpen(record, "M")}
                      >
                        {record.pharmacyOrderId}
                      </span>
                    </div>
                  ) : (
                    <span className="bg-[#31E4A81A] text-green-600 px-4 py-2 rounded-md text-sm w-[104px] h-[28px] ">
                      {record.drugPrescriptionStatus
                        ? record.drugPrescriptionStatus
                        : "N/A"}
                    </span>
                  )}
                </td>
                <td className="p-3 whitespace-nowrap">
                  {record.labPrescriptionStatus == "Tested" ? (
                    <div className="flex justify-center gap-1 items-center">
                      <span
                        className=" border p-1 rounded-md border-brand-primaryColor cursor-pointer"
                        onClick={() => handlePharmaMedOpen(record, "L")}
                      >
                        {record.labOrderId}
                      </span>
                      <img
                        src={Preview}
                        alt="Preview"
                        className="w-6 h-6 rounded-md cursor-pointer"
                        onClick={() => {
                          setShowLabReport(true);
                          setLabReportData(record);
                        }}
                      />
                    </div>
                  ) : (
                    <span className="bg-[#31E4A81A] text-green-600 px-4 py-2 rounded-md text-sm w-[104px] h-[28px] ">
                      {record.labPrescriptionStatus
                        ? record.labPrescriptionStatus
                        : "N/A"}
                    </span>
                  )}
                </td>
                <td className="p-3">
                  {record.status === 9 && (
                    <span
                      className="px-4 py-2 rounded-md text-sm bg-[#FF60601A] text-red-600 "
                      disabled
                    >
                      Cancelled
                    </span>
                  )}
                  {record.status === 0 && (
                    <span className="px-4 py-2 rounded-md text-sm bg-[#EBA8171A] text-yellow-600">
                      Pending
                    </span>
                  )}
                  {record.status === 1 && (
                    <span className="px-4 py-2 rounded-md text-sm bg-[#EBA8171A] text-yellow-600">
                      Pending
                    </span>
                  )}
                  <div className="flex gap-3">
                    {record.status === 2 && (
                      <span className="px-4 py-2 rounded-md text-sm bg-[#31E4A81A] text-green-600 ">
                        Completed
                      </span>
                    )}
                    {record.status === 2 && record.serviceCode === "APPT_INPERSON" &&
                      <Summary
                        record={record}
                      />
                    }
                  </div>
                </td>
                <td>
                  {record.status === 1 ? (
                    <div className="p-3 flex gap-2">
                      <Tooltip placement="top" title={"Cancel Appointment"}>
                        <div
                          onClick={() => showModal(record)}
                          className="w-8 h-8 rounded-full bg-red-200 flex items-center justify-center cursor-pointer"
                        >
                          <img src={close} alt="" />
                        </div>
                      </Tooltip>
                      <Tooltip placement="top" title={"Share Link"}>
                        {" "}
                        <div className="w-8 h-8 rounded-full bg-[#DEF3F2] flex items-center justify-center cursor-pointer">
                          <RWebShare
                            data={{
                              text: "Appointment",
                              url:
                                `${process.env.REACT_APP_WEBSITEURL}vc?ref=` +
                                record?.appointmentId +
                                "/N",
                              title: "Share Link",
                            }}
                          >
                            <img src={Share} alt="" />
                          </RWebShare>
                        </div>
                      </Tooltip>
                      <RescheduleAppt
                        record={record}
                        getList={appointmentsList}
                      />
                    </div>
                  ) : (
                    <div className="p-3 flex gap-2">
                      <div className="w-8 h-8 rounded-full text-white bg-gray-300 flex items-center justify-center cursor-not-allowed">
                        <IoMdClose />
                      </div>
                      <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                        <img src={ShareWhite} alt="" />
                      </div>
                      <div className="w-8 h-8 rounded-full text-white bg-gray-300 flex items-center justify-center cursor-not-allowed">
                        <FaCalendarAlt className="text-white" />
                      </div>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <NoAppointmentsCard />
      )}
      {showLabReport && (
        <Modal
          title="Lab Reports"
          open={showLabReport}
          onCancel={() => {
            setShowLabReport(false);
          }}
          style={{
            top: 40,
          }}
          width={800}
          footer={null}
        >
          <ViewLabReports labReportData={labReportData} />
        </Modal>
      )}

      {pharmaMed && (
        <Modal
          title=""
          open={pharmaMed}
          onCancel={handlePharmaMedClose}
          style={{
            top: 40,
          }}
          width={1000}
          footer={null}
        >
          {previewType === "M" ? (
            <MedOrderPreview medRecord={medRecord} />
          ) : (
            <LabOrderPreview medRecord={medRecord} />
          )}
        </Modal>
      )}
      <Modal
        open={preview}
        onOk={handlePreviewOk}
        onCancel={handlePreviewCancel}
        style={{
          top: 40,
        }}
        width={"70%"}
        footer={null}
      >
        <PrescriptionDetails
          prescription={selectedPrescription}
          selectedPatient={selectedPatient}
        />
      </Modal>
      <Modal
        title="Cancel Appointment"
        open={isModalOpen}
        // onOk={handleOk}
        onCancel={cancelAppointment}
        footer={[]}
        width={400}
        destroyOnClose
      >
        <div>
          <span className="font-sans font-normal text-s">
            Are you sure you want to cancel this appointment?
          </span>
          <div className="relative mt-5">
            <textarea
              onChange={(e) => {
                setCancelReason(e.target.value);
              }}
              rows="4"
              className="peer w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-[#189FAA] text-sm font-medium text-[#333] bg-transparent"
            />
            <label
              className="absolute left-2 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#959595] peer-focus:-top-2 peer-focus:text-[#189FAA] peer-focus:text-[10px] bg-white px-1"
              htmlFor="cancelReason"
            >
              Cancel Reason...
            </label>
            <Checkbox
              checked={refundable}
              disabled={
                cancelAppointmentID?.status === 0 ||
                cancelAppointmentID?.status === 9 ||
                (cancelAppointmentID?.paymentType === "FullDiscount" &&
                  cancelAppointmentID?.status === 1)
                //   ||
                // cancelAppointmentID?.paymentType === "Cash"
              }
              onChange={handleRefundable}
              className="text-[#969CA5] gap-2"
            />
            <label className="text-[#A0A2A3] ">Refund Applicable</label>
          </div>
          <div className="flex justify-end border-brand-colorBorder gap-3 mt-10">
            <Button
              className="h-8 Btnwhite  w-20 text-[#189FAA]"
              onClick={cancelAppointment}
            >
              Cancel
            </Button>
            <Button
              onClick={handleOk}
              className="h-8 w-40 font-sans font-semibold bg-brand-primaryColor"
              type="primary"
            >
              Ok
            </Button>
          </div>
        </div>
      </Modal>

      {showLabReport && (
        <Modal
          title="Lab Reports"
          open={showLabReport}
          onCancel={() => {
            setShowLabReport(false);
          }}
          style={{
            top: 40,
          }}
          width={800}
          footer={null}
        >
          <ViewLabReports labReportData={labReportData} />
        </Modal>
      )}

      {pharmaMed && (
        <Modal
          title=""
          open={pharmaMed}
          onCancel={handlePharmaMedClose}
          style={{
            top: 40,
          }}
          width={1000}
          footer={null}
        >
          {previewType === "M" ? (
            <MedOrderPreview medRecord={medRecord} />
          ) : (
            <LabOrderPreview medRecord={medRecord} />
          )}
        </Modal>
      )}
    </div>
  );
}

export default Appointments;
